import { getSamoletIcons, saasIcons } from '../constants/iconConfigs';
import { TAppVersion } from '../api/types';
import { isSaaS } from './isSaaS';

/**
 * Ранняя установка иконок до загрузки React
 */
export const setupEarlyFavicon = (stand: TAppVersion) => {
  // Удаляем существующие иконки
  const existingIcons = document.querySelectorAll(
    'link[rel*="icon"], link[rel="apple-touch-icon"], link[rel="shortcut icon"]',
  );
  existingIcons.forEach(icon => icon.remove());

  // Определяем окружение
  const isSaaSApp = isSaaS();

  let icons: Array<{ rel: string; type: string; href: string; sizes?: string }> = [];

  if (isSaaSApp) {
    // Для SaaS используем SaaS иконки
    icons = saasIcons;
  } else {
    // Для Самолета используем соответствующие иконки
    icons = getSamoletIcons(stand);
  }

  // Устанавливаем иконки
  icons.forEach(icon => {
    const link = document.createElement('link');
    link.rel = icon.rel;
    link.type = icon.type;
    link.href = icon.href;
    if (icon.sizes) {
      link.setAttribute('sizes', icon.sizes);
    }
    document.head.appendChild(link);
  });
};
